up.framework.startExtension();
require('./unpoly-migrate/migrate');
require('./unpoly-migrate/classes/config');
require('./unpoly-migrate/classes/render_job');
require('./unpoly-migrate/classes/render_result');
require('./unpoly-migrate/classes/layer/base');
require('./unpoly-migrate/util');
require('./unpoly-migrate/error');
require('./unpoly-migrate/browser');
require('./unpoly-migrate/element');
require('./unpoly-migrate/event');
require('./unpoly-migrate/script');
require('./unpoly-migrate/form');
require('./unpoly-migrate/fragment');
require('./unpoly-migrate/framework');
require('./unpoly-migrate/history');
require('./unpoly-migrate/status');
require('./unpoly-migrate/link');
require('./unpoly-migrate/layer');
require('./unpoly-migrate/modal');
require('./unpoly-migrate/popup');
require('./unpoly-migrate/tooltip');
require('./unpoly-migrate/protocol');
require('./unpoly-migrate/network');
require('./unpoly-migrate/radio');
require('./unpoly-migrate/viewport');
up.framework.stopExtension();
